import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {AccountGroups, GroupCategories,} from "../../../redux/actions/Modules.Action";
import ApiConnect from "../../../Utils/ApiConnect";

class Groups extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      myFData: [],
      subCategory: [],
      btnDisable: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Group Name",
        selector: row => row.name,
      },
      {
        name: "Category",
        selector: row => row.group,
        sortable: true,
      },
      {
        name: "Sub Category",
        selector: row => row.subcategory,
        sortable: true,
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",

        cell: (row) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button className="table-action btn btn-square btn-pure hover-danger">
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchAccountGroups();
  }
  fetchCategory() {
    if (this.props.GroupCategory.length === 0) {
      ApiConnect.get("/Module/Accounts/AccountHead/GroupCategoryDetails")
        .then((response) => {
          this.props.GroupCategories(response.data);
        })
        .catch((error) => console.log(error));
    }
  }
  fetchSubCategory(e) {
    ApiConnect.get(
      `/Module/Accounts/AccountHead/GroupSubCategoryDetails?symbol=${e}`
    )
      .then((response) => {
        this.setState({ subCategory: response.data });
      })
      .catch((error) => console.log(error));
  }
  fetchAccountGroups() {
    ApiConnect.get("/Module/Accounts/AccountHead/GroupDetails")
      .then((response) => {
        this.props.AccountGroups(response.data);
      })
      .catch((error) => console.log(error));
  }
  handleChange(e) {
    const newFdata = { ...this.state.myFData };
    newFdata[e.target.name] = e.target.value;
    this.setState({ myFData: newFdata });
  }
  handleFormSubmit(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("name", this.state.myFData.name);
    Fdatas.append("category", this.state.myFData.category);
    Fdatas.append("subcategory", this.state.myFData.subcategory);
    ApiConnect({
      method: "post",
      url: "/Module/Accounts/AccountHead/NewAccountGroup",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          this.setState({
            myFData: [],
            formError: false,
          });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.fetchAccountGroups();
        } else if (response.data.status) {
          toast.danger(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  }
  render() {
    const filteredData = this.props.AccountGroupData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Account Groups</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                    this.fetchCategory();
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Account Group</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.handleFormSubmit(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Group Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        required
                        value={this.state.myFData.name || ""}
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Category</label>
                      <label className="col-12">
                        <select
                          className="form-control"
                          name="category"
                          value={this.state.myFData.category || ""}
                          onChange={(e) => {
                            this.fetchSubCategory(e.target.value);
                            this.handleChange(e);
                          }}
                        >
                          <option value="">---Select Group---</option>
                          {this.props.GroupCategory.map((grp, index) => (
                            <option value={grp.symbol} key={index}>
                              {grp.name}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Sub Category</label>
                      <select
                        className="form-control"
                        name="subcategory"
                        value={this.state.myFData.subcategory || ""}
                        onChange={(e) => this.handleChange(e)}
                      >
                        <option value="">---Select Group---</option>
                        {this.state.subCategory.map((grp, index) => (
                          <option value={grp.id} key={index}>
                            {grp.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={this.state.btnDisable}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    GroupCategory: state.Accounts.GroupCategory,
    AccountGroupData: state.Accounts.AccountGroup,
  }),
  { GroupCategories, AccountGroups }
)(Groups);
